export const COMPONENT_CONTAINER_IDENTIFIER = 'digitalFemsaComponentContainer';

export const PLUGIN_ONLY_METADATA_KEYS = ['shopify_order'];
export const MAX_LENGTH_MERCHANT_NAME = 30;
